export const version = '1.0.0';
export const navbarBreakPoint = 'xl';
// NYU's central Accessibility page, where people report barriers (NYU Digital Accessibility Policy, 2025)
export const nyuAccessibilityUrl = 'https://www.nyu.edu/footer/accessibility.html';
